import { useMemo, useCallback } from 'react';
import {
  CEFR_NAME,
  CEFR_RL_NAME,
  MCER_NAME,
  PLACEMENT_NAME,
  EPT_NAME,
} from 'constants';

const useTestType = ({ testType }) => {
  const upperTestType = useMemo(
    () => (testType || '').toUpperCase(),
    [testType]
  );

  const { isCefr, isCefrRL, isMcer, isPlacement } = useMemo(
    () => ({
      isCefr: upperTestType.includes(CEFR_NAME),
      isCefrRL: upperTestType.includes(CEFR_RL_NAME),
      isMcer: upperTestType.includes(MCER_NAME),
      isPlacement:
        upperTestType.includes(PLACEMENT_NAME) ||
        upperTestType.includes(EPT_NAME),
    }),
    [upperTestType]
  );

  const getScoreByTestType = useCallback(
    (score) => {
      if (isCefr) return score.score_cefr;
      if (isMcer) return score.score_mcer;
      return score.score;
    },
    [isCefr, isMcer]
  );

  const isPending = useCallback(
    (score) => {
      if (isCefr) return !score.score_cefr;
      if (isMcer) return !score.score_mcer;
      return !score.score;
    },
    [isCefr, isMcer]
  );

  return {
    isCefr,
    isCefrRL,
    isMcer,
    isPlacement,
    getScoreByTestType,
    isPending,
  };
};

export { useTestType };
